import {UserDataDto} from "acc-rest-client";
import ReactCountryFlag from 'react-country-flag';


export const userStatusLabels = {
    "NEW_REGISTERED_ACCOUNT": "New",
    "APPROVAL_RQUESTED": "Pending",
    "APPROVED":"Active",
    "REJECTED": "Rejected",
    "DEACTIVATED": "Inactive",
    "UNVERIFIED": "Unverified",
    "TAJNEED_MISSING": "Tajneed missing"
}

export const userStatusFilterDropdown = Object.keys(userStatusLabels).map((status) => {
    return { text: userStatusLabels[status], value: status };
})

export const getUserStatusLabel = (user: UserDataDto): string => {
    const status = user.approvalStatus;
    return  userStatusLabels[status] || status; // Default to red if no match
}

export const formatRoleName = (name) =>
    (name || "")
        .replace(/^amj-/, "")
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

// Highlighted, human-readable label for a role; falls back to the prettified
// technical name when the role has no description.
export const getRoleLabel = (role) =>
    role?.description || formatRoleName(role?.name);

export const getCustomUnicodeFlagIcon = (countryCode) => {
    let code;
    if (!countryCode){
        return "";
    }
    else if (countryCode?.toUpperCase() === 'UK') {
        code = 'GB';
    }
    else {
        code = countryCode?.toUpperCase();
    }

    return <ReactCountryFlag countryCode={code} svg style={{ width: '1.2em', height: '1.2em' }} />;
}